/**
 * The two lengths of time the Seat sessions page shows for a seat, worked out against one clock so
 * they move together: how long since its last heartbeat, and how long until another device may
 * take it. The server answers the second as it stood when it answered, so it counts down from the
 * moment that answer arrived and starts over from the server's figure at the next fetch. Both are
 * whole seconds and, like every length of time the panel writes, cut rather than rounded up: the
 * countdown loses a second as soon as part of one has passed.
 */

/** Seconds since `iso`, as of `now`. */
export const secondsSince = (iso: string, now: number) => Math.floor((now - new Date(iso).getTime()) / 1000);

/**
 * Seconds until the seat may be reclaimed, as of `now`: the server's `reclaimableInSeconds` less
 * the time since the answer carrying it arrived (`fetchedAt`), never above that figure and never
 * below zero.
 */
export const secondsUntilReclaimable = (reclaimableInSeconds: number, fetchedAt: number, now: number) =>
  Math.max(0, reclaimableInSeconds - Math.max(0, Math.ceil((now - fetchedAt) / 1000)));
